var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpcomingIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    fill: "#F3F5FA",
    fillOpacity: 0.4,
    stroke: "#E5EAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6934 10H11.3061C10.0343 10 9 11.0349 9 12.3061V19.2433C9 20.5151 10.0349 21.5494 11.3061 21.5494H15.3215L18.5935 23.9322C18.6545 23.9769 18.7267 23.9992 18.7996 23.9992C18.854 23.9992 18.9085 23.9867 18.9584 23.9611C19.0758 23.9014 19.15 23.7806 19.15 23.6494V21.5495H20.6934C21.9652 21.5495 23 20.5146 23 19.2434V12.3061C23 11.0344 21.9651 10 20.6934 10ZM22.2999 19.2438C22.2999 20.1297 21.5793 20.8496 20.6934 20.8496H18.8001C18.6066 20.8496 18.4504 21.0065 18.4504 21.1994V22.9613L15.643 20.9165C15.5833 20.8725 15.5111 20.8496 15.4369 20.8496H11.3073C10.4214 20.8496 9.70151 20.129 9.70151 19.2438V12.3065C9.70151 11.4206 10.4221 10.7007 11.3073 10.7007H20.6947C21.5806 10.7007 22.3011 11.4212 22.3011 12.3065V19.2438L22.2999 19.2438Z",
    fill: "#2361FF",
    stroke: "#2361FF",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2701 13.961C18.9118 13.7819 18.4905 13.8199 18.1702 14.0601L17.5022 14.5615C17.4313 14.0509 16.9962 13.6559 16.4666 13.6559H13.2C12.6212 13.6559 12.15 14.1271 12.15 14.7059V17.1949C12.15 17.7737 12.6212 18.2448 13.2 18.2448H16.4666C16.9962 18.2448 17.4306 17.8491 17.5022 17.3392L18.1702 17.8406C18.3559 17.9804 18.5764 18.0519 18.7989 18.0519C18.9584 18.0519 19.1198 18.0152 19.2694 17.9397C19.6271 17.7605 19.8495 17.4009 19.8495 17.0006V14.9007C19.8495 14.5004 19.6271 14.1408 19.2694 13.9616L19.2701 13.961ZM16.817 17.1949C16.817 17.3878 16.6602 17.5447 16.4673 17.5447H13.2006C13.0077 17.5447 12.8508 17.3878 12.8508 17.1949V14.7059C12.8508 14.513 13.0077 14.3561 13.2006 14.3561H16.4673C16.6602 14.3561 16.817 14.513 16.817 14.7059V17.1949ZM19.1506 17C19.1506 17.1352 19.0784 17.2527 18.957 17.313C18.8356 17.3741 18.6985 17.3616 18.5902 17.2802L17.5173 16.475V15.4244L18.5902 14.6192C18.6985 14.5378 18.8356 14.5254 18.957 14.5864C19.0785 14.6468 19.1506 14.7642 19.1506 14.8994V17Z",
    fill: "#2361FF",
    stroke: "#2361FF",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingIcon);
export default __webpack_public_path__ + "static/media/upcomingIcon.15ec903db99546dbb27eca78c9cf52ee.svg";
export { ForwardRef as ReactComponent };